import { BaseModel } from "@/core/standard/BaseModel";
import AddressService from "@/modules/addresses/AddressService";
import {
  IAddressModel,
  IAddresses,
  AddressProtocol,
} from "@/modules/addresses/IAddressModel";

const address = {
  address: "",
  city: "",
  town: "",
  postal_code: "",
  reference: '', 
  principal: false,
};

class AddressModel extends BaseModel<IAddressModel, AddressProtocol> {
  public modelName = "Direcciones";

  public request = "JSON";

  constructor() {
    super(address, AddressService);
  }
}

export default AddressModel as new () => IAddresses;
